import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import AddNewPlant from "./pages/addNewPlant";
import Home from "./pages/appHome";
import PlantsPage from "./pages/plantsPage";
import RoAdvisorHome from "./pages/home";
import LifetimeAdvisorHome from "./pages/lifetimeAdvisorHome";
import AnalyseData from "./pages/analyseData";
import { RootLayout } from "./RootLayout";

import { updatePlantId } from "./utils/Utils";
import { API_URLS } from "./network/appUrls";
import NotAuthorized from "./pages/unauthorized";
import RequestAccess from "./pages/requesAccessPage";
import MessagePage from "./pages/messageDisplayPage";
import AdminPage from "./pages/AdminPortal";
import UserPage from "./pages/AdminPortal/userManage";

const searchParams = new URLSearchParams(window.location.search);
const plantId = searchParams.get("plantId");
updatePlantId(plantId);

const basePath = API_URLS.basePath;

const routes = [
  {
    element: <RootLayout />,
    children: [
      {
        path: "",
        element: <PlantsPage />,
      },
      {
        path: "plants",
        element: <PlantsPage />,
      },
      // remove this route later(added for users who have bookmarked /plant page, to avoid breaking their bookmark)
      {
        path: "plant",
        element: <Navigate to="/plants" replace />,
      },
      {
        path: "addPlant",
        element: <AddNewPlant />,
      },
      {
        path: "editPlant",
        element: <AddNewPlant />,
      },
      {
        path: "analyseData",
        element: <AnalyseData />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "cleaningAdvisorHome",
        element: <RoAdvisorHome />,
      },
      {
        path: "lifetimeAdvisorHome",
        element: <LifetimeAdvisorHome />,
      },
      {
        path: "unauthorized",
        element: <NotAuthorized />,
      },
      {
        path: "requestAccess",
        element: <RequestAccess />,
      },
      {
        path: "messagePage",
        element: <MessagePage />,
      },
      {
        path: "admin-portal",
        element: <AdminPage />,
      },
      {
        path: "user-management",
        element: <UserPage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  basename: basePath,
});
